<template>
  <page
    :custom-style="{
      display: 'flex',
      'flex-direction': 'column',
      height: '100vh',
      backgroundColor: '#F5F5F5',
      paddingTop: pagePaddingTop
    }"
  >
    <maple-nav-bar
      v-if="!browerInfo.isMiniProgram"
      class="navbar"
      left-arrow
      :safe-top-distance="statusBarHeight"
      opacity-style
      title="填写新品信息"
      @click-left="goBack"
    />
    <div class="add-container">
      <!-- <transition name="fade"> -->
      <!-- 第一步 -->
      <div v-show="step == 1" id="formContainer1" class="form-container">
        <div class="form-group">
          <div class="form-block">
            <label>名称</label>
            <suggest
              ref="commodityNameSuggest"
              :init-value="formData.commodityName"
              :input-value.sync="formData.commodityName"
              :placeholder="'请填写商品名称'"
              :maxlength="50"
              :data="{ type: 1, initSuggest: step == 1 }"
            ></suggest>
          </div>
          <div class="form-block last" @click="handleSelect">
            <label>分类</label>
            <div v-if="formData.categoryName" class="form-item">
              {{ formData.categoryName }}
            </div>
            <div v-if="!formData.categoryName" class="form-item placeholder">
              请选择商品分类
            </div>
            <IconFont name="mc-icon-arrowright" size="12px" color="#c7c7c7" />
          </div>
        </div>
        <div class="desc">以上两项为必填项</div>
        <div
          class="sub-btn"
          :class="[
            {
              disabled: !formData.commodityName || !formData.categoryName
            },
            ...themeAppColorClass
          ]"
          @click="nextStep"
        >
          下一步
        </div>
      </div>
      <!-- </transition> -->
      <!-- 第二步 -->
      <!-- <transition name="fade"> -->
      <div v-show="step == 2" id="formContainer2" class="form-container">
        <div class="form-group">
          <div class="form-block">
            <label>品牌</label>
            <suggest
              ref="brandSuggest"
              :input-value.sync="formData.brand"
              :placeholder="'例：百事、农夫'"
              :maxlength="50"
              :data="{
                type: 2,
                container: '#formContainer2',
                initSuggest: step == 2
              }"
            ></suggest>
          </div>
          <div class="form-block">
            <label>规格</label>
            <input
              v-model="formData.specifications"
              type="text"
              placeholder="例：250ml×24瓶/箱"
              maxlength="100"
            />
          </div>
          <div class="form-block">
            <label>条形码</label>
            <input
              v-model="formData.barCode"
              v-check="checkQRCode"
              type="tel"
              placeholder="请输入数字条形码"
              maxlength="14"
            />
            <img
              v-show="browerInfo.isMallApp"
              class="qr-icon"
              :src="qrCodeImg"
              width="40"
              @click="qrcode"
            />
          </div>
          <div class="form-block">
            <label>月需求量</label>
            <input
              v-model="formData.monthReq"
              type="text"
              placeholder="预计一个月购买量"
              maxlength="20"
            />
          </div>
          <div class="form-block">
            <label>备注</label>
            <input
              v-model="formData.remark"
              type="text"
              placeholder="品种、口味、产地等信息"
              maxlength="200"
            />
          </div>
          <!-- 上传图片 -->
          <div class="img-upload-wrapper">
            <label>上传照片</label>
            <img-upload
              ref="imgUpload"
              :pics.sync="formData.upPics"
              :oss-data="ossData"
            ></img-upload>
            <div class="demo">
              <p>参照如下图片上传清晰商品照。</p>
              <div class="imgs" @click.prevent>
                <img src="@/images/new_good_req/demo1.png" />
                <img src="@/images/new_good_req/demo2.png" />
                <img src="@/images/new_good_req/demo3.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="desc">此页所有项为非必填项</div>
      </div>
      <!-- </transition> -->
    </div>
    <div
      v-show="step == 2"
      class="sub-btn sub-btn-main"
      :class="themeBgColorClass"
      @click="submit"
    >
      提交
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="categoryList"
        title="商品分类"
        @confirm="onConfirmPopup"
        @cancel="onClosePopup"
      />
    </van-popup>
  </page>
</template>

<script>
import { scanQrCode } from '@/utils/qrCode.js'
import { resolveUrlParams } from '@/utils/utils'
import Suggest from './widget/Suggest.vue'
import ImgUpload from './widget/ImgUpload.vue'
import Validate from './widget/Validate.vue'
import { NativeEvent } from '@mc/mc-jsbridge'
import { API } from '@/api'
import themeMixin from '@/common/mixins/theme'
import { qrCodeImg } from '@/defines/environment/config'
const FORM_DATA = {
  commodityName: '',
  categoryName: '',
  categoryId: '',
  barCode: '',
  brand: '',
  specifications: '',
  remark: '',
  monthReq: '', // 月需求量
  upPics: []
}
export default {
  components: { Suggest, ImgUpload },
  mixins: [Validate, themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      browerInfo: window.matrix,
      formData: Object.assign({}, FORM_DATA),
      categoryList: [],
      step: 1,
      onScanResult: false,
      showPicker: false,
      ossData: {},
      qrCodeImg
    }
  },
  computed: {
    pagePaddingTop() {
      if (!window.matrix.isMiniProgram) {
        if (!window.matrix.isMallApp) {
          return 44 + this.statusBarHeight + 'px'
        }
        return 44 + this.statusBarHeight + 'px'
      } else {
        return '0px'
      }
    }
  },
  updated() {
    NativeEvent.on('onScanResult', res => {
      if (this.onScanResult) {
        return
      }
      if (res.ret === 1) {
        const validate = this.checkQRCode({ val: res.data.code })
        if (!validate.validate) {
          this.$toast('请扫描数字条形码')
          return
        }
        this.formData.barCode = res.data.code
        this.onScanResult = true
      }
    })
  },
  methods: {
    async init() {
      this.step = 1
      const params = resolveUrlParams()
      this.formData = Object.assign({}, FORM_DATA, {
        commodityName: params.search ? decodeURI(params.search) : '' // 填写默认值
      })
      this.categoryList = []
      this.$nextTick(() => {
        this.$refs.commodityNameSuggest.inputValue = this.formData.commodityName
        this.$refs.brandSuggest.inputValue = this.formData.brand
      })

      this.$refs.imgUpload.init()
      this.isSearching = false
      try {
        const resData = await API.newReqGood.getNewGoodReqSaleClass()
        const list = resData.list || []
        this.newGoodReqSaleClass = list
        list.forEach(item => {
          this.categoryList.push(item.name)
        })
        const res = await API.newReqGood.getOssKey({
          source_key: 'mall-entrance'
        })
        this.ossData = res
      } catch (e) {
        this.$toast({
          message: '加载类型列表失败',
          duration: 1000
        })
      }

      if (params.search) {
        this.$nextTick(() => {
          this.$refs.commodityNameSuggest.$refs.sugInput.focus()
        })
      }
    },
    back(type) {
      if (type !== 'back' && this.step > 1) {
        this.step--
        return
      }

      // 未填写过直接返回
      if (!this.formData.commodityName && !this.formData.categoryName) {
        this.goBack()
        return
      }
      this.$dialog
        .confirm({
          message: '确定离开？<br/>离开后将不保存当前填写内容',
          confirmButtonText: '返回修改',
          cancelButtonText: '确定'
        })
        .then(() => {
          this.goBack()
        })
        .catch(() => {
          this.goBack()
        })
    },
    qrcode() {
      this.onScanResult = false
      scanQrCode(2)
        .then(res => {
          if (res && res.code) {
            const validate = this.checkQRCode({ val: res.code })
            if (!validate.validate) {
              this.$toast('请扫描数字条形码')
              return
            }
            this.formData.barCode = res.code
          }
        })
        .catch(e => {
          if (e && e.status === 'NO_AUTH') {
            this.$toast('没有权限使用摄像头')
          } else if (typeof e === 'string') {
            this.$toast({ message: e, duration: 3000 })
          }
        })
    },
    handleSelect() {
      this.showPicker = true
      const selectIdx = this.categoryList.findIndex(item => {
        return item.id === this.formData.categoryId
      })
      this.defaultSelectIndex = selectIdx === -1 ? 0 : selectIdx
    },
    onConfirmPopup(selectValue, selectIndex) {
      this.showPicker = false
      this.formData.categoryId = this.newGoodReqSaleClass[selectIndex].id
      this.formData.categoryName = selectValue
    },
    onClosePopup() {
      this.showPicker = false
    },
    nextStep() {
      if (!this.formData.commodityName || !this.formData.categoryName) {
        return
      }
      this.step++
    },
    async submit() {
      if (this.isSearching) {
        return
      }
      const validateErrors = this.checkAll()
      if (validateErrors && validateErrors.length) {
        this.$toast(validateErrors[0])
        return
      }

      this.$track(
        this.$trackMap.newGoodReq.nameSuggest,
        this.$refs.commodityNameSuggest.fetchTickData()
      )
      const formData = this.formData
      this.$Loading()
      this.isSearching = true
      try {
        const params = {
          commodity_name: formData.commodityName,
          sale_class1_id: formData.categoryId,
          graphic_code: formData.barCode,
          brand: formData.brand,
          specifications: formData.specifications,
          remark: formData.remark,
          pictures: formData.upPics,
          monthly_demand: formData.monthReq
        }
        const res = await API.newReqGood.createNewGoodReq(params)
        this.$Loading.hide()
        this.isSearching = false
        this.$toast({
          message: '提交成功',
          duration: 2000
        })
        this.$router.replace({
          path: '/new-good-req/detail',
          query: {
            reqId: res.demand_id
          }
        })
      } catch (e) {
        this.$Loading.hide()
        this.isSearching = false
        if (e.error) {
          this.$toast({
            message: e.error.msg
          })
        }
      }
    },
    goBack() {
      this.$back()
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  position: fixed;
  top: 0;
  z-index: $z-navigation-bar;

  width: 100vw;
}
.add-container {
  height: 0;
  overflow: scroll;

  background-color: #fff;

  flex: auto;
}

.form-group {
  margin-bottom: 0.1rem;

  background: #fff;
}
.form-block {
  display: flex;

  position: relative;

  height: 1.2rem;
  margin: 0 0.33rem;

  background: #fff;
  border-bottom: 1px solid #e8e8e8;

  align-items: center;

  font-size: 0.34rem;
  line-height: 0.44rem;
  color: #333333;
  &.last {
    border: 0 none;
  }

  .meicai-icon-right-arrow {
    position: relative;
    top: 0.04rem;

    color: #c7c7cc;
  }
  .qr-icon {
    display: block;

    width: 0.72rem;
    height: 0.72rem;
  }
}

label,
input {
  line-height: 0.44rem;
}
label {
  display: block;

  width: 2.08rem;

  flex-shrink: 0;

  font-size: 0.34rem;
  color: #000;
}

input,
div.form-item {
  display: block;

  padding: 0;
  overflow: hidden;

  outline: none;

  flex: 1;

  font-size: 0.34rem;

  &::placeholder {
    color: #999;
  }
}

.form-item.placeholder {
  color: #999;
}

.sub-btn {
  display: block;

  width: 7.1rem;
  height: 0.94rem;
  margin: 0.3rem auto 0;

  background: #0daf52;
  border-radius: 0.1rem;
  border: 0 none;
  outline: 0 none;

  font-size: 0.36rem;
  line-height: 0.94rem;
  color: #fff;

  @include flex-row-center;
  &.small {
    background: $theme-main_small;
    &.disabled {
      background: #ddd;

      color: #bbb;
    }
  }
  &.disabled {
    background: #ddd;

    color: #bbb;
  }
}
.sub-btn-main {
  width: 100%;
  margin-top: 0;

  border-radius: 0;
}

.img-upload-wrapper {
  padding-left: 0.33rem;
  label {
    margin: 0.3rem 0;
  }
  .demo {
    margin-top: 0.19rem;
    padding-bottom: 0.67rem;
    p {
      margin-bottom: 0.11rem;

      font-size: 0.24rem;
      line-height: 0.51rem;
      color: #999;
    }

    .imgs {
      img {
        width: 1.6rem;
        height: 1.1rem;

        margin-right: 0.1rem;
      }
    }
  }
}

.desc {
  margin-top: 0.16rem;
  margin-bottom: 0.3rem;
  margin-left: 0.27rem;

  font-size: 0.24rem;
  color: #999;
}
.close-btn {
  display: inline-block;

  width: 0.4rem;
  height: 0.4rem;

  margin-left: 0.3rem;

  font-size: 0.3rem;
  line-height: 0.4rem;
  font-weight: bold;

  vertical-align: middle;
  color: #0daf52;
}
.back {
  display: inline-block;

  vertical-align: middle;
}
</style>
